import * as z from 'zod';

import { tcCategoryUpdateSchema } from './tc-category-mutation-schema';

export const tcCategoryFormSchema = tcCategoryUpdateSchema
  .omit({
    name: true,
    sku_prefix: true,
  })
  .extend({
    name: z.string().min(3),
    sku_prefix: z.string().length(3),
  });

export type TcCategoryFormSchema = z.infer<typeof tcCategoryFormSchema>;
